var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "49px",
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-6",
    transform: "translate(-1030, -407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1030, 407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#FFE1E3",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(15, 11)",
    fill: "#8B131C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,25 C10.0844245,23.9344118 18,16.1764706 18,9.15367647 C18,4.11727941 13.9883525,0 9,0 C4.01164752,0 0,4.11727941 0,9.15367647 C0,16.1764706 7.91557555,23.9341912 9,25 Z M4.77110611,9.3375 C4.77110611,6.94779412 6.68721182,5.03639706 9,5.03639706 C11.3495863,5.03639706 13.2288939,6.98522059 13.2288939,9.3375 C13.2288939,11.7272059 11.3127882,13.6386037 9,13.6386037 C6.65041369,13.640039 4.77110611,11.6912132 4.77110611,9.3375 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconRed);
export default __webpack_public_path__ + "static/media/location-icon--red.1a7c4aceee761cc78613aef3b4d9c32f.svg";
export { ForwardRef as ReactComponent };